<template>
<div>
    <!-- <top-bar></top-bar> -->
    <top-slider></top-slider>
    <top-menu></top-menu>

    <div class="page_content_box">
        <div class="wrap">

            <div class="detail">
                <h1>{{detailContent.title}}</h1>
                <div class="source"><span>发布日期:</span>{{detailContent.date}}</div>
                <div class="content">
                    <div class="content_detail" v-html="detailContent.content"></div>
                    <div class="file" v-if="showFiles">
                        <h2>附件:</h2>
                        <ul>
                            <li v-for="item in detailContent.files" :key="item.name"><a :href="item.url">{{item.name}}</a></li>
                        </ul>
                    </div>

                    <!-- 我的报名 -->
                    <div class="sign_up_box">
                        <h2>我的报名</h2>
                        <el-form ref="form" label-width="80px" style="margin-top:20px">
                            <el-form-item v-for="(item,index) in form" :key="index" :label="item.name">
                                <el-input v-model="item.value" :disabled="true">{{item.value}}</el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import { getTrainDetail } from '@/service/api.js'
import {dateFormat, createContentMeta} from '@/utils/util.js'
import TopMenu from '@/components/TopMenu.vue'
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopSlider from '@/components/TopSlider.vue'
export default {
    // components: { TopMenu,TopBar,Footer,TopSlider },
    components: { TopMenu,Footer,TopSlider },
    data() {
        return {
            detailContent:{
                title:'',
                date:'',
                files:[],
            },
            showFiles:false,
            form:[],
        }
    },
    mounted () {
        getTrainDetail(this.$route.params.id).then(data=>{
            console.log('getTrainDetail',data);
            // 内容展示
            this.detailContent.title = data.data.title;
            this.detailContent.date = dateFormat(data.data.pushTime,'Y年M月D日');
            if (data.data.files) {
                this.detailContent.files = JSON.parse(data.data.files)
            }
            if(this.detailContent.files.length>0){
                this.showFiles = true
            }
            this.detailContent.content = data.data.content

            // 表单生成
            this.form = data.data.mapList
            this.form.forEach(el => {
                el.value = JSON.stringify(el.value).slice(1,JSON.stringify(el.value).length-1)
            });
            // 添加meta标签
            let temp = {
                'ColumnName': this.detailContent.title,
                'ColumnType': this.detailContent.title,
                'ArticleTitle': this.detailContent.title,
                'PubDate': this.detailContent.date,
                'ContentSource': this.detailContent.source,
                'Author': this.detailContent.author
            }
            createContentMeta(temp)
        });
    },
}
</script>
<style lang="less">
.dynamic_form {
    .input_code {
        width: 190px;
    }
    .el-date-editor--date {
        width: 100%;
    }
    .verCodeImg {
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: solid 1px #DCDFE6;
        border-radius: 5px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        color: #999;
        cursor: pointer;
    }
    .el-button--primary {
        width: 150px;
        height: 40px;
        background-color: #18388b;
        border: none;
    }
}
</style>
<style lang="less" scoped>
.sign_up_box {
    width: 500px;
    margin: 40px auto 0;
    h2 {
        font-size: 20px;
        font-weight: 600;
        border-bottom: dashed 1px #DDD;
    }
    .dynamic_form {
        width: 400px;
        margin: 20px auto 0;
    }
}
.detail {
    padding: 0 50px 50px;
    overflow: hidden;
    min-height: 600px;
    h1 {
        font-size: 24px;
        line-height: 1.4;
        margin-top: 40px;
        text-align: center;
    }
    .source {
        font-size: 14px;
        text-align: center;
        line-height: 1;
        margin-top: 20px;
        color: #999;
    }
    .content {
        margin-top: 20px;
        line-height: 2;
        text-align: justify;
        img {
            max-width: 1100px;
        }
    }
    .file {
        margin-top: 20px;
        h2 {
            font-weight: 600;
        }
        ul {
            padding-left: 2em;
            li {
                line-height: 1;
                margin-top: 10px;
                a {
                    color: #18388b;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>